import React from "react";
import { useParams } from "react-router-dom";
import { Footer, Header } from "../components/Layouts";
import { ServicesContainer } from "../components/Services";

const Services = () => {
  const params = useParams();
  const { slug } = params;
  return (
    <div>
      <Header />
      <ServicesContainer slug={slug} />
      <Footer />
    </div>
  );
};

export default Services;
